import { Checkbox, FormControlLabel, FormHelperText } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

interface RHFCheckboxProps {
  name: string;
  helperText?: React.ReactNode;
  sx?: object;
  onChange?: (event: React.SyntheticEvent<Element, Event>) => void;
  [key: string]: any;
}

export function RHFCheckbox({
  name,
  helperText,
  sx,
  onChange,
  value,
  ...other
}: RHFCheckboxProps & { value?: string }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const isArray = Array.isArray(field.value);
        const checked = isArray
          ? field.value.includes(value)
          : Boolean(field.value);

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          let newValue: any;

          if (isArray) {
            newValue = checked
              ? field.value.filter((v: string) => v !== value)
              : [...field.value, value];
          } else {
            newValue = e.target.checked;
          }

          field.onChange(newValue);
          onChange?.(e);
        };

        return (
          <div>
            <FormControlLabel
              label={undefined}
              control={
                <Checkbox checked={checked} onChange={handleChange} sx={sx} />
              }
              {...other}
            />
            {(!!error || helperText) && (
              <FormHelperText error={!!error}>
                {error ? error?.message : helperText}
              </FormHelperText>
            )}
          </div>
        );
      }}
    />
  );
}
